import * as React from 'react';

interface ICheckboxInputProps {
    name: string;
    label: string;
    icon?: string;
    onChange: (e: any) => void;
    checked?: boolean;
    disabled?: any;
    error?: any;
}

const CheckboxInput = (props: ICheckboxInputProps) => {
    let wrapperClass = 'input-group checkbox-for-label';
    if (props.error && props.error.length > 0) {
        wrapperClass += ' has-error';
    }

    return (
        <div className={wrapperClass}>
            <div className="field">
                <input
                    type="checkbox"
                    id={props.name}
                    name={props.name}
                    className="form-control"
                    checked={props.checked}
                    disabled={props.disabled}
                    onChange={props.onChange}
                />
                <label htmlFor={props.name}>
                    {props.icon && <i className="material-icons">{props.icon}</i>}
                    {props.label}
                </label>
                {props.error && <div className="alert alert-danger">{props.error}</div>}
            </div>
        </div>
    );
};

export default CheckboxInput;
